<div aria-labelledby="dropdownConfig">
  <div *ngIf="!filterDateValidation">
    <span style="color: red;font-weight: bold;" *ngIf="!filterDateValidation">التاريخ الى اكبر من التاريخ من</span>
  </div>
  <div>
    <h4 [qcId]="'filter-window'" class="filter-title text-black">التصفية</h4>
    <form [formGroup]="form_Group" (ngSubmit)="onFilter()">
      <div class="row align-items-baseline">
        <div class="col-md-6 fromDate">
          <label>التاريخ</label>
          <ng-container *ngIf="!isHijriDate">
            <app-datepicker-gregorian [qcId]="'from-date'" [displayFooter]="true"
              (onDateSelect)="selectStartDate($event)" #datePickerFromGregorian [placeHolder]="'من'">
            </app-datepicker-gregorian>
          </ng-container>
          <ng-container *ngIf="isHijriDate">
            <app-datepicker-umalqura [qcId]="'from-date'" [placeHolder]="'من'" (onDateSelect)="selectStartDate($event)"
              #datePickerFromHijri>
            </app-datepicker-umalqura>
          </ng-container>
        </div>
        <div class="col-md-6 toDate">
          <div class="custom-control custom-checkbox d-flex flex-row-reverse hijri">
            <input class="custom-control-input" [ngModelOptions]="{ standalone: true }" type="checkbox" value=""
              [(ngModel)]="isHijriDate" id="hijriDate" [qcId]="'ishijriDate'"/>
            <label class="custom-control-label" for="hijriDate">
              التاريخ الهجري
            </label>
          </div>
          <ng-container *ngIf="!isHijriDate">
            <app-datepicker-gregorian [qcId]="'to-date'" [placeHolder]="'الى'" [displayFooter]="false"
              (onDateSelect)="selectEndDate($event)" #datePickerToGregorian>
            </app-datepicker-gregorian>
          </ng-container>
          <ng-container *ngIf="isHijriDate">
            <app-datepicker-umalqura [qcId]="'to-date'" (onDateSelect)="selectEndDate($event)" [placeHolder]="'الى'"
              #datePickerToHijri>
            </app-datepicker-umalqura>
          </ng-container>
        </div>
        <div [qcId]="'error-date'" class="text-danger pl-3">
          {{ errorMessage }}
        </div>
      </div>
      <div class="row align-items-baseline">
        <div class="col-sm-6 col-12">
          <div class="form-group">
            <label for="text" class="mb-3">
              {{ "AdminDonorRequest.requestType" | translate }}
            </label>
            <ng-select [qcId]="'request-type'" width="100%" [items]="requestTypes" bindValue="id" bindLabel="name"
              formControlName="requestType" [multiple]="false" [placeholder]="'Global.Choose' | translate">
            </ng-select>
          </div>
        </div>

        <div class="col-sm-6 col-12">
          <div class="form-group">
            <label for="text" class="mb-3">
              {{ "AdminDonorRequest.requestStatus" | translate }}
            </label>
            <ng-select [qcId]="'request-status'" width="100%" [items]="requestStatus" bindValue="id" bindLabel="name"
              formControlName="requestStatus" [multiple]="false" [placeholder]="'Global.Choose' | translate">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="dropdown-footer d-flex justify-content-end">
        <button [qcId]="'reset-btn'" class="btn btn-outline-default" (click)="resetForm()">
          <i class="fa-solid fa-rotate-right"></i>
          <span> اعادة تعيين </span>
        </button>
        <button [qcId]="'submit-btn'" class="btn btn-green">
          تطبيق التصفية
        </button>
      </div>
    </form>
  </div>
</div>